<div class="cart-order-item-option-item">
  <span class="cart-order-item-option-item__qty">{{ quantity() }}x</span>
  <span class="cart-order-item-option-item__text">{{ name() }}</span>
  @if (formattedTotal()) {
    <span class="cart-order-item-option-item__total">{{ formattedTotal() }}</span>
  }
</div>
@if (stockWarningLabel()) {
  <pxw-tag class="cart-order-item-option-item__stock" size="xs" type="warning">
    <pxw-icon icon="alert" />
    {{ stockWarningLabel() }}
  </pxw-tag>
}
